<template>
    <ul
        class="collection collection-alone with-header"
        id="filter-plataforma-origem"
    >
        <li class="collection-header pl-0">
            <span class="Search__title grey-text pl-0">
                Por Plataforma de Origem:
            </span>
        </li>
        <li
            class="collection-item dismissable pb-0"
            style="
                touch-action: pan-y;
                -webkit-user-drag: none;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
            v-for="item in plataformaOrigemOptions"
            :key="item.value"
        >
            <input
                type="radio"
                v-model="plataformaOrigemModel"
                :value="item.value"
                :id="`plataforma-origem-${item.value}`"
                v-on:change="handleChangePlataformaOrigem(item)"
            />
            <label :for="`plataforma-origem-${item.value}`"></label>
            <span class="title title-alone" style="width: 100%">
                {{ item.label }}
            </span>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'FiltroPorPlataformaOrigem',

    props: {
        plataformaOrigem: {
            default: () => ''
        }
    },

    data() {
        return {
            plataformaOrigemOptions: [
                {
                    label: 'Todos',
                    value: ''
                },
                {
                    label: 'Segasp Univalores',
                    value: 1
                },
                {
                    label: 'Própria',
                    value: 2
                }
            ]
        };
    },

    methods: {
        handleChangePlataformaOrigem(plataformaOrigem) {
            this.$emit('change', { plataformaOrigem: plataformaOrigem.value });
        }
    },

    computed: {
        plataformaOrigemModel: {
            get() {
                return this.plataformaOrigem;
            },

            set(value) {}
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/lead/listagem/FiltroPorPlataformaOrigem.vue